import React from 'react';
import productLinks from '../../utils/config/productLinks';
import serviceLinks from '../../utils/config/serviceLinks';
import {Trans} from 'react-i18next';
import i18n from '../../utils/i18n';
import technologyLinks from '../../utils/config/technologyLinks';
import webUtils from '../../utils/webUtils';

export default [
  {
    id: 'menu.business.solutions',
    text: (
      <Trans i18nKey="business:c.l.f.menudefinitions.solutions">
        Solutions
      </Trans>
    ),
    i18nKey: 'business:c.l.f.menudefinitions.solutions',
    items: [
      productLinks.virtualmakeup,
      productLinks.youcamtutorial,
      productLinks.aishadefinder,
      productLinks.background,
      // productLinks.aifacialrecognition,
      productLinks.arskindiagnostic,
      productLinks.skinemulation,
      productLinks.aifaceanalyzer,
      productLinks.facereshaping,
      productLinks.aipersonality,
      // productLinks.instorebarcode,
      productLinks.livehaircolor,
      productLinks.hairstyle,
      productLinks.hairtype,
      productLinks.aibearddye,
      productLinks.virtualaccessories,
      productLinks.ar3deyewear,
      productLinks.nailColor,
      productLinks.threedviewer,
      productLinks.arwatch,
      productLinks.arring,
      productLinks.arbracelet,
      productLinks.arearring,
      productLinks.arnecklace,
    ],
  },
  {
    id: 'menu.business.services',
    text: <Trans i18nKey="business:p.b.s.e.s.menu.services">Services</Trans>,
    i18nKey: 'business:p.b.s.e.s.menu.services',
    items: [
      serviceLinks.onlineservice,
      serviceLinks.onlineserviceeyewear,
      serviceLinks.instoreconsultation,
      serviceLinks.youcam4web,
      // productLinks.livestreaming,
      // productLinks.ba1on1,
      // productLinks.liveartraining,
      serviceLinks.youcam4google,
      serviceLinks.virtualmakeupsnapchat,
      serviceLinks.virtualmakeupinstagram,
      serviceLinks.wechatminiprogram,
      serviceLinks.taobaominiprogram,
      serviceLinks.sdk,
      serviceLinks.applisting,
      // serviceLinks.facebookarchatbot,
      serviceLinks.douyinminiprogram,
    ],
  },
  {
    id: 'menu.consumer.technologyLinks',
    text: technologyLinks.home.text,
    i18nKey: technologyLinks.home.i18nKey,
    items: [
      // technologyLinks.agileface,
      technologyLinks.agilehand,
      technologyLinks.makeupar,
      technologyLinks.live3dfacear,
      technologyLinks.skincarear,
      technologyLinks.faceai,
    ],
  },
  {
    id: 'menu.business.company',
    text: (
      <Trans i18nKey="business:c.l.f.menudefinitions.company">Company</Trans>
    ),
    i18nKey: 'business:c.l.f.menudefinitions.company',
    items: [
      {
        id: 'menu.business.aboutus',
        text: (
          <Trans i18nKey="business:c.l.f.menudefinitions.about.us">
            About Us
          </Trans>
        ),
        i18nKey: 'business:c.l.f.menudefinitions.about.us',
        link: '/business/info/aboutus',
      },
      {
        id: 'menu.business.newsevents',
        text: <Trans i18nKey="business:p.b.h.news.title">News</Trans>,
        i18nKey: 'business:p.b.h.news.title',
        link: '/business/news/list',
      },
      {
        id: 'menu.business.awards',
        text: <Trans i18nKey="business:p.b.h.awards.title">Awards</Trans>,
        i18nKey: 'business:p.b.h.awards.title',
        link: '/business/info/awards',
      },
      {
        id: 'menu.business.contactus',
        text: (
          <Trans i18nKey="business:c.l.f.menudefinitions.contact.us">
            Contact Us
          </Trans>
        ),
        i18nKey: 'business:c.l.f.menudefinitions.contact.us',
        link: '/business/contact-us',
      },
      {
        id: 'menu.business.investors',
        text: (
          <Trans i18nKey="business:c.l.f.menudefinitions.investors">
            Investors
          </Trans>
        ),
        i18nKey: 'business:c.l.f.menudefinitions.investors',
        link: 'https://ir.perfectcorp.com/',
      },
      {
        id: 'menu.business.esg',
        text: (
          <Trans i18nKey="business:c.l.f.menudefinitions.esg">
            ESG Commitments
          </Trans>
        ),
        i18nKey: 'business:c.l.f.menudefinitions.esg',
        link: '/business/info/esg',
      },
      {
        id: 'menu.business.partners',
        text: (
          <Trans i18nKey="business:c.l.f.menudefinitions.partners">
            Partners
          </Trans>
        ),
        i18nKey: 'business:c.l.f.menudefinitions.partners',
        link: '/business/partners',
      },
      {
        id: 'menu.business.career',
        text: (
          <Trans i18nKey="business:c.l.f.menudefinitions.career">Career</Trans>
        ),
        i18nKey: 'business:c.l.f.menudefinitions.career',
        link: webUtils.jobLink(),
      },
      {
        id: 'menu.business.compliance',
        text: (
          <Trans i18nKey="business:c.l.f.menudefinitions.compliance">
            Compliance
          </Trans>
        ),
        i18nKey: 'business:c.l.f.menudefinitions.compliance',
        link: '/business/compliance',
      },
    ],
  },
  {
    id: 'menu.business.resources',
    text: (
      <Trans i18nKey="business:c.l.s.leftmenu.demo.resources">Resources</Trans>
    ),
    i18nKey: 'business:c.l.s.leftmenu.demo.resources',
    items: [
      {
        id: 'menu.business.videos',
        text: (
          <Trans i18nKey="business:c.l.s.leftmenu.demo.video">Videos</Trans>
        ),
        i18nKey: 'business:c.l.s.leftmenu.demo.video',
        link: '/business/videos',
      },
      {
        id: 'menu.business.blog',
        text: <Trans i18nKey="business:c.l.s.leftmenu.demo.blog">Blog</Trans>,
        i18nKey: 'business:c.l.s.leftmenu.demo.blog',
        link: '/business/blog/1',
      },
      {
        id: 'menu.business.stories',
        text: (
          <Trans i18nKey="business:c.l.s.leftmenu.demo.story">
            Success Stories
          </Trans>
        ),
        i18nKey: 'business:c.l.s.leftmenu.demo.story',
        link: '/business/successstory/list',
      },
      {
        id: 'menu.business.beautyTrend',
        text: (
          <Trans i18nKey="business:c.l.f.menudefinitions.color.report">
            Beauty Trend Report
          </Trans>
        ),
        i18nKey: 'business:c.l.f.menudefinitions.color.report',
        link: '/business/color-list',
      },
      {
        id: 'menu.business.btf',
        text: (
          <Trans i18nKey="business:c.l.f.menudefinitions.btf">
            Beauty Tech Forum Master Series
          </Trans>
        ),
        i18nKey: 'business:c.l.f.menudefinitions.btf',
        link: '/business/beauty-tech-forum-master-class',
      },
      // {
      //   id: 'menu.business.education',
      //   text: (
      //     <Trans i18nKey="business:c.l.f.menudefinitions.education">
      //       Beauty Tech Forum Education Series
      //     </Trans>
      //   ),
      //   i18nKey: 'business:c.l.f.menudefinitions.education',
      //   link: '/business/education-series',
      // },
      {
        id: 'menu.business.btfv',
        text: (
          <Trans i18nKey="business:c.l.f.menudefinitions.gbtf2021">
            Global Beaty & Fashion AI Forum
          </Trans>
        ),
        i18nKey: 'business:c.l.f.menudefinitions.gbtf2021',
        link: '/business/global-beauty-tech-forum',
      },
      // {
      //   id: 'menu.business.ces2022',
      //   text: (
      //     <Trans i18nKey="business:c.l.f.menudefinitions.ces.2022">
      //       Beauty & Fashion Metaverse
      //     </Trans>
      //   ),
      //   link: '/business/beauty-fashion-metaverse',
      //   i18nKey: 'business:c.l.f.menudefinitions.ces.2022',
      // },
    ],
  },
  {
    id: 'menu.business.support',
    text: (
      <Trans i18nKey="business:c.l.f.menudefinitions.support">Support</Trans>
    ),
    i18nKey: 'business:c.l.f.menudefinitions.support',
    items: [
      {
        id: 'menu.business.faq',
        text: <Trans i18nKey="business:c.l.f.menudefinitions.faq">FAQ</Trans>,
        i18nKey: 'business:c.l.f.menudefinitions.faq',
        link: '/business/faq',
      },
      {
        id: 'menu.business.doc',
        text: (
          <Trans i18nKey="business:c.l.f.menudefinitions.document.center">
            Document Center
          </Trans>
        ),
        i18nKey: 'business:c.l.f.menudefinitions.document.center',
        link: `${webUtils.getEnvReactAppUrl()}/document-center/${
          i18n.language === 'ja' ? 'ja' : 'en'
        }/`,
        notFollow: true,
      },
      {
        id: 'menu.business.terms',
        text: (
          <Trans i18nKey="business:c.l.f.menudefinitions.terms">
            Terms of Service
          </Trans>
        ),
        i18nKey: 'business:c.l.f.menudefinitions.terms',
        link: '/business/terms',
        notFollow: true,
      },
      {
        id: 'menu.business.privacy',
        text: (
          <Trans i18nKey="business:c.l.f.menudefinitions.privacy">
            Privacy Policy
          </Trans>
        ),
        i18nKey: 'business:c.l.f.menudefinitions.privacy',
        link: '/business/privacy',
        notFollow: true,
      },
      {
        id: 'menu.business.impressum',
        text: (
          <Trans i18nKey="business:c.l.f.menudefinitions.imrpessum">
            Impressum
          </Trans>
        ),
        i18nKey: 'business:c.l.f.menudefinitions.imrpessum',
        link: '/business/impressum',
      },
    ],
  },
];
